import { EndpointBuilder } from '@reduxjs/toolkit/query';
import {
  FetchArgs,
  FetchBaseQueryError,
  FetchBaseQueryMeta
} from '@reduxjs/toolkit/query';
import { BaseQueryFn } from '@reduxjs/toolkit/query';
import {
  MeterProfileDataTableNewResponse,
  MeterProfileDataTableOgResponse
} from '../../types';

export const InstantaneousProfileEndpoints = (
  builder: EndpointBuilder<
    BaseQueryFn<
      string | FetchArgs,
      unknown,
      FetchBaseQueryError,
      NonNullable<unknown>,
      FetchBaseQueryMeta
    >,
    string,
    'hesApi'
  >
) => ({
  getProfileInstantData: builder.query<
    MeterProfileDataTableNewResponse,
    { searchQuery: string }
  >({
    query: ({ searchQuery }) => ({
      url: `/push-data/profile-instant${searchQuery}`,
      method: 'GET'
    }),
    transformResponse: (
      response: MeterProfileDataTableOgResponse
    ): MeterProfileDataTableNewResponse => {
      const records = !response.data.records ? [] : response.data.records;
      // .map(record => {
      //   const { data, ...rest } = record;
      //   const { num_power_fail_dur, ...dataItems } = data;
      //   const finalResponse: MeterProfileDataTableRecordTransformed = { ...rest, ...dataItems };
      //   if(num_power_fail_dur) {
      //     finalResponse['cumulative_power_off_duration'] = num_power_fail_dur
      //   }
      //   return finalResponse
      // })
      return {
        ...response,
        data: {
          ...response.data,
          records: records,
          keyOrder: response.data.keyOrder,
          obisCodeMap: response.data.obisCodeMap
        }
      };
    }
  })
});
